import * as yup from "yup";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Input, Label,Modal,ModalHeader,ModalBody,ModalFooter } from "reactstrap";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import Auth from "../services/authService";
import { CreateAccount, DoNotHaveAccount, EmailAddress, ForgotPassword, Href, Password, RememberPassword, SignIn, SignInAccount, SignInWith } from "../constants";
import { useAppDispatch } from "../reduxToolkit/hooks";
import { login,setLoginTime} from "../reduxToolkit/reducers/layout/authSlice";

import { setRole } from "../reduxToolkit/reducers/roles/roleSlice";
import SocialLink from "./SocialLink";
import { routes } from "../routers/routes";
import { getRoleFromToken } from "../utils/jwtDecode";
import ApiService from "../services/apiService";
import { setUserId } from "../reduxToolkit/reducers/users/userSlice";
import { setCookies,getCookies } from "../utils/cokkiesUtil";
import { method } from "lodash";
import { format } from "date-fns";

// Yup is a schema builder for runtime value parsing and validation


//Login form
const SignInForm = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const toggle = () => setPasswordVisible(!isPasswordVisible);
  const [isDeleteModalOpen,setIsDeleteModalOpen] = useState(false)
  const [input,setInput] = useState()
  

  // useForm is a custom hook for managing forms with ease, with yupResolver to validate the form schema
  const { register, handleSubmit, formState: { errors } } = useForm();
  
  const handleChange = (e:any) =>{
      setInput(e.target.value)
  }

  const onEmailSubmit = async (input:any) =>{
      
    try{
       const response = await ApiService.axiosApi(`/auth/forget-password`,{
         method:'POST',
         data:{
           EmailAddress:input
         }
       })
       if(response.success){
          toast.success(response.message||"Reset Link has been sent to your Email")
          setIsDeleteModalOpen(false)
       }else{
         toast.error(response.message||"Invalid Email")
       }
    }catch(error){
       console.log(error)
    }
  }
  

  const onSubmit = async (data: any) => {
    try {
      const response = await Auth.login(data.email, data.password);
      
      if (response.success) {
         getUserId(data.email)
        toast.success("Login Success...!");
      
        
        dispatch(login(response.data.jwtToken));
        dispatch(setLoginTime(format(new Date(),'yyyy-MM-dd HH:mm:ss')))
        const role = getRoleFromToken(response.data.jwtToken);
        
        dispatch(setRole(role));

       
          navigate(routes.MapView);
       
      }
      else{
        toast.error(response.data|| "Login failed. Please try again.");
      }
    } catch (error: any) {
      // Log the full error object to see its structure
      console.log('Full error object:', error);
      
      // Access error message from the API response
      const errorMessage = error.response?.data?.message || 
                         error.response?.data || 
                         error.message || 
                         "An unexpected error occurred";
      
      toast.error(errorMessage);
    }
  };

  const getUserId = async(data:any) =>{
      const email = {
          
        EmailAddress : data,
      }
     try{
      const response = await ApiService.axiosApi('/auth/getuserbyemail',{
         method: 'POST',
         data : email,
      })
      if(response.success){
         
         dispatch(setUserId(response.data.id))
      }else{
         console.log("unable to get userid")
      }
     }catch(error:any){
       console.log(error)
     }
  }
  
  return (
    <>
    <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
      <h3>{SignInAccount}</h3>
      <p>{"Enter your email & password to login"}</p>
      <FormGroup>
        <Label className="col-form-label">{EmailAddress}</Label>
        <input 
          className="form-control" 
          type="email" 
           defaultValue={"akash@123.com"}
          {...register("email", { 
            required: "Email is required",
           
          })} 
        />
        {errors.email && <p className="text-danger mt-1">{errors.email.message?.toString()}</p>}
      </FormGroup>
      <FormGroup>
        <Label className="col-form-label">{Password}</Label>
        <div className="form-input position-relative">
          <input 
            className="form-control" 
            type={isPasswordVisible ? "text" : "password"} 
            defaultValue={"akash@12345"}
            {...register("password", { 
              required: "Password is required",
               
            })} 
          />
          <div className="show-hide" onClick={toggle}>
            <span className={!isPasswordVisible ? "show" : ""}> </span>
          </div>
        </div>
        {errors.password && <p className="text-danger mt-1">{errors.password.message?.toString()}</p>}
      </FormGroup>
      <div className="form-group mb-0">
        <div className="checkbox p-0  justify-content-between">
          <Input id="checkbox1" type="checkbox" />
          <Label className="text-muted" htmlFor="checkbox1">{RememberPassword}</Label>
          <span style={{marginLeft:'80px'}} onClick={()=>setIsDeleteModalOpen(true)}>{ForgotPassword}</span>
        </div>
         
        <div className="text-end mt-3">
          <Button color="primary" className="w-100" block>{SignIn}</Button>
        </div>
      </div>
      
    </Form>

<Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
<ModalHeader>Email Address Link to Your Account</ModalHeader>
<ModalBody>
     <div style={{marginLeft:'90px'}}>
    <label>Email Address:</label>
    </div>
  <div className="d-flex justify-content-center">
   <input type="text"
       style={{width:'300px',marginLeft:'10PX',height:'33px',borderRadius:'5px',border:'1px solid grey'}}
   
       onChange={handleChange}
        value ={input} />
        </div>
</ModalBody>
<ModalFooter>
  <Button color="danger" onClick={() => onEmailSubmit(input)}>send</Button>
  <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
</ModalFooter>
</Modal>

</>
  );
};

export default SignInForm;